/* eslint-disable */
/**
 * * This file was automatically generated by react-scripts-trackman codegen.
 * * DO NOT MODIFY IT BY HAND. Instead, modify endpoint definitions in backend,
 * * start backend to regenerate swagger.json, and run react-scripts-trackman codegen
 * * to regenerate this file.
 * *
 * * If you find errors in this file, do the following (in order):
 * * 1. Check Swagger configuration in backend (often SwaggerResponse is wrongly defined)
 * * 2. Check backend type and controller definitions
 * * 3. Check if the endpoint is properly defined in consumedEndpoints.json
 * * 4. Report the issue to react-scripts-trackman maintainers (mga@trackman.com)
 */

import {
  BatterReportFilterDto,
  BatterPlayerReportResultDto,
  UmpireReportFilterDto,
  UmpireReportResultDto,
  UmpireReportForSessionFilterDto,
  UmpireReportForSessionResultDto,
  UmpireReportForAdminFilterDto,
  UmpireReportForAdminResultDto,
  PlayerReportContentConfigDto,
  PitcherPlayerReportResultDto,
  UpdatePitcherReportSetupDto,
  PitcherReportFilterDto,
  PitcherLayoutResultDto,
  UpdatePitcherReportLayoutDto,
  PitcherSessionReportFilterDto,
  PitcherSessionReportResultDto,
  BatterSessionReportFilterDto,
  BatterSessionReportResultDto,
  UpdateBatterReportSetupDto,
  BatterLayoutResultDto,
  UpdateBatterReportLayoutDto,
  UpdatePitcherSessionReportSetupDto,
  PitcherSessionReportLayoutResultDto,
  UpdatePitcherSessionReportLayoutDto,
  UpdateBatterSessionReportSetupDto,
  BatterSessionReportLayoutResultDto,
  UpdateBatterSessionReportLayoutDto,
  UmpireReportContentConfigDto,
  UpdateAllSessionsUmpireReportSetupDto,
  UmpireLayoutResultDto,
  UpdateUmpireReportLayoutDto,
  UpdateSingleSessionUmpireReportSetupDto,
  UmpireLayoutForSessionResultDto,
  UpdateUmpireReportForSessionLayoutDto,
  UmpireReportForAdminContentConfigDto,
  UpdateAdminOverviewUmpireReportSetupDto,
  UmpireLayoutForAdminResultDto,
  UpdateUmpireReportForAdminLayoutDto,
  BatterSingleSessionReportResultDto,
  UpdateBatterSingleSessionReportSetupDto,
  BatterSingleSessionReportFilterDto,
  BatterSingleSessionReportLayoutResultDto,
  UpdateBatterSingleSessionReportLayoutDto,
  PitcherSingleSessionReportResultDto,
  UpdatePitcherSingleSessionReportSetupDto,
  PitcherSingleSessionReportFilterDto,
  PitcherSingleSessionReportLayoutResultDto,
  UpdatePitcherSingleSessionReportLayoutDto,
  PracticeBatterSingleSessionReportLayoutResultDto,
  PracticeBatterSingleSessionReportFilterDto,
  PracticeBatterSingleSessionReportResultDto,
  UpdatePracticeBatterSingleSessionReportSetupDto,
  UpdatePracticeBatterSingleSessionReportLayoutDto,
  PracticeBatterSessionReportResultDto,
  UpdatePracticeBatterSessionReportSetupDto,
  PracticeBatterSessionReportFilterDto,
  PracticeBatterSessionReportLayoutResultDto,
  UpdatePracticeBatterSessionReportLayoutDto,
  PracticePitcherSingleSessionReportResultDto,
  UpdatePracticePitcherSingleSessionReportSetupDto,
  PracticePitcherSingleSessionReportFilterDto,
  PracticePitcherSingleSessionReportLayoutResultDto,
  UpdatePracticePitcherSingleSessionReportLayoutDto,
  PracticePitcherSessionReportResultDto,
  UpdatePracticePitcherSessionReportSetupDto,
  PracticePitcherSessionReportFilterDto,
  PracticePitcherSessionReportLayoutResultDto,
  UpdatePracticePitcherSessionReportLayoutDto,
  ExternalBatterReportResultDto,
  ExternalBatterReportLayoutResultDto,
  ExternalPitcherReportResultDto,
  ExternalPitcherReportLayoutResultDto,
} from '../types/CodegenReportTypes';
import { AxiosInstance } from 'axios';
import { Result } from '../types/CodegenResult';

export class ReportService {
  private axiosInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  postReportPlayerReportBatterGenerate = async (requestBody: BatterReportFilterDto) => {
    const response = await this.axiosInstance.post<Result<BatterPlayerReportResultDto>>(
      `/api/v1/Report/playerReport/batter/generate`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportUmpireReportAllSessionsGenerate = async (requestBody: UmpireReportFilterDto) => {
    const response = await this.axiosInstance.post<Result<UmpireReportResultDto>>(
      `/api/v1/Report/umpireReport/allSessions/generate`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportUmpireReportSingleSessionGenerate = async (requestBody: UmpireReportForSessionFilterDto) => {
    const response = await this.axiosInstance.post<Result<UmpireReportForSessionResultDto>>(
      `/api/v1/Report/umpireReport/singleSession/generate`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportUmpireReportAdminOverviewGenerate = async (requestBody: UmpireReportForAdminFilterDto) => {
    const response = await this.axiosInstance.post<Result<UmpireReportForAdminResultDto>>(
      `/api/v1/Report/umpireReport/adminOverview/generate`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportPlayerReportPitcherGetReportData = async (requestBody: PlayerReportContentConfigDto, reportId?: string) => {
    const response = await this.axiosInstance.post<Result<PitcherPlayerReportResultDto>>(
      `/api/v1/Report/playerReport/pitcher/get-report-data`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportPlayerReportPitcherUpdateReportSetup = async (requestBody: UpdatePitcherReportSetupDto, reportId?: string) => {
    const response = await this.axiosInstance.post<Result<PitcherPlayerReportResultDto>>(
      `/api/v1/Report/playerReport/pitcher/update-report-setup`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportPlayerReportPitcherGenerate = async (requestBody: PitcherReportFilterDto) => {
    const response = await this.axiosInstance.post<Result<PitcherPlayerReportResultDto>>(
      `/api/v1/Report/playerReport/pitcher/generate`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  getReportPlayerReportPitcherOrgLayout = async () => {
    const response = await this.axiosInstance.get<Result<PitcherLayoutResultDto>>(`/api/v1/Report/playerReport/pitcher/org-layout`);
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportPlayerReportPitcherOrgLayout = async (requestBody: UpdatePitcherReportLayoutDto) => {
    const response = await this.axiosInstance.post<Result<UpdatePitcherReportLayoutDto>>(
      `/api/v1/Report/playerReport/pitcher/org-layout`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportPitcherAggregatedGenerate = async (requestBody: PitcherSessionReportFilterDto) => {
    const response = await this.axiosInstance.post<Result<PitcherSessionReportResultDto>>(
      `/api/v1/Report/sessionReviewReport/pitcherAggregated/generate`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportBatterAggregatedGenerate = async (requestBody: BatterSessionReportFilterDto) => {
    const response = await this.axiosInstance.post<Result<BatterSessionReportResultDto>>(
      `/api/v1/Report/sessionReviewReport/batterAggregated/generate`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportPlayerReportBatterGetReportData = async (requestBody: PlayerReportContentConfigDto, reportId?: string) => {
    const response = await this.axiosInstance.post<Result<BatterPlayerReportResultDto>>(
      `/api/v1/Report/playerReport/batter/get-report-data`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportPlayerReportBatterUpdateReportSetup = async (requestBody: UpdateBatterReportSetupDto, reportId?: string) => {
    const response = await this.axiosInstance.post<Result<BatterPlayerReportResultDto>>(
      `/api/v1/Report/playerReport/batter/update-report-setup`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  getReportPlayerReportBatterOrgLayout = async () => {
    const response = await this.axiosInstance.get<Result<BatterLayoutResultDto>>(`/api/v1/Report/playerReport/batter/org-layout`);
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportPlayerReportBatterOrgLayout = async (requestBody: UpdateBatterReportLayoutDto) => {
    const response = await this.axiosInstance.post<Result<UpdateBatterReportLayoutDto>>(
      `/api/v1/Report/playerReport/batter/org-layout`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportPitcherAggregatedGetReportData = async (requestBody: PlayerReportContentConfigDto, reportId?: string) => {
    const response = await this.axiosInstance.post<Result<PitcherSessionReportResultDto>>(
      `/api/v1/Report/sessionReviewReport/pitcherAggregated/get-report-data`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportPitcherAggregatedUpdateReportSetup = async (
    requestBody: UpdatePitcherSessionReportSetupDto,
    reportId?: string
  ) => {
    const response = await this.axiosInstance.post<Result<PitcherSessionReportResultDto>>(
      `/api/v1/Report/sessionReviewReport/pitcherAggregated/update-report-setup`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  getReportSessionReviewReportPitcherAggregatedOrgLayout = async () => {
    const response = await this.axiosInstance.get<Result<PitcherSessionReportLayoutResultDto>>(
      `/api/v1/Report/sessionReviewReport/pitcherAggregated/org-layout`
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportPitcherAggregatedOrgLayout = async (requestBody: UpdatePitcherSessionReportLayoutDto) => {
    const response = await this.axiosInstance.post<Result<UpdatePitcherSessionReportLayoutDto>>(
      `/api/v1/Report/sessionReviewReport/pitcherAggregated/org-layout`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportBatterAggregatedGetReportData = async (requestBody: PlayerReportContentConfigDto, reportId?: string) => {
    const response = await this.axiosInstance.post<Result<BatterSessionReportResultDto>>(
      `/api/v1/Report/sessionReviewReport/batterAggregated/get-report-data`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportBatterAggregatedUpdateReportSetup = async (
    requestBody: UpdateBatterSessionReportSetupDto,
    reportId?: string
  ) => {
    const response = await this.axiosInstance.post<Result<BatterSessionReportResultDto>>(
      `/api/v1/Report/sessionReviewReport/batterAggregated/update-report-setup`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  getReportSessionReviewReportBatterAggregatedOrgLayout = async () => {
    const response = await this.axiosInstance.get<Result<BatterSessionReportLayoutResultDto>>(
      `/api/v1/Report/sessionReviewReport/batterAggregated/org-layout`
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportBatterAggregatedOrgLayout = async (requestBody: UpdateBatterSessionReportLayoutDto) => {
    const response = await this.axiosInstance.post<Result<UpdateBatterSessionReportLayoutDto>>(
      `/api/v1/Report/sessionReviewReport/batterAggregated/org-layout`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportUmpireReportAllSessionsGetReportData = async (requestBody: UmpireReportContentConfigDto, reportId?: string) => {
    const response = await this.axiosInstance.post<Result<UmpireReportResultDto>>(
      `/api/v1/Report/umpireReport/allSessions/get-report-data`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportUmpireReportAllSessionsUpdateReportSetup = async (requestBody: UpdateAllSessionsUmpireReportSetupDto, reportId?: string) => {
    const response = await this.axiosInstance.post<Result<UmpireReportResultDto>>(
      `/api/v1/Report/umpireReport/allSessions/update-report-setup`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  getReportUmpireReportAllSessionsOrgLayout = async () => {
    const response = await this.axiosInstance.get<Result<UmpireLayoutResultDto>>(`/api/v1/Report/umpireReport/allSessions/org-layout`);
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportUmpireReportAllSessionsOrgLayout = async (requestBody: UpdateUmpireReportLayoutDto) => {
    const response = await this.axiosInstance.post<Result<UpdateUmpireReportLayoutDto>>(
      `/api/v1/Report/umpireReport/allSessions/org-layout`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportUmpireReportSingleSessionGetReportData = async (requestBody: UmpireReportContentConfigDto, reportId?: string) => {
    const response = await this.axiosInstance.post<Result<UmpireReportForSessionResultDto>>(
      `/api/v1/Report/umpireReport/singleSession/get-report-data`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportUmpireReportSingleSessionUpdateReportSetup = async (
    requestBody: UpdateSingleSessionUmpireReportSetupDto,
    reportId?: string
  ) => {
    const response = await this.axiosInstance.post<Result<UmpireReportForSessionResultDto>>(
      `/api/v1/Report/umpireReport/singleSession/update-report-setup`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  getReportUmpireReportSingleSessionOrgLayout = async () => {
    const response = await this.axiosInstance.get<Result<UmpireLayoutForSessionResultDto>>(
      `/api/v1/Report/umpireReport/singleSession/org-layout`
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportUmpireReportSingleSessionOrgLayout = async (requestBody: UpdateUmpireReportForSessionLayoutDto) => {
    const response = await this.axiosInstance.post<Result<UpdateUmpireReportForSessionLayoutDto>>(
      `/api/v1/Report/umpireReport/singleSession/org-layout`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportUmpireReportAdminOverviewGetReportData = async (requestBody: UmpireReportForAdminContentConfigDto, reportId?: string) => {
    const response = await this.axiosInstance.post<Result<UmpireReportForAdminResultDto>>(
      `/api/v1/Report/umpireReport/adminOverview/get-report-data`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportUmpireReportAdminOverviewUpdateReportSetup = async (
    requestBody: UpdateAdminOverviewUmpireReportSetupDto,
    reportId?: string
  ) => {
    const response = await this.axiosInstance.post<Result<UmpireReportForAdminResultDto>>(
      `/api/v1/Report/umpireReport/adminOverview/update-report-setup`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  getReportUmpireReportAdminOverviewOrgLayout = async () => {
    const response = await this.axiosInstance.get<Result<UmpireLayoutForAdminResultDto>>(
      `/api/v1/Report/umpireReport/adminOverview/org-layout`
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportUmpireReportAdminOverviewOrgLayout = async (requestBody: UpdateUmpireReportForAdminLayoutDto) => {
    const response = await this.axiosInstance.post<Result<UpdateUmpireReportForAdminLayoutDto>>(
      `/api/v1/Report/umpireReport/adminOverview/org-layout`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportBatterSingleSessionGetReportData = async (requestBody: PlayerReportContentConfigDto, reportId?: string) => {
    const response = await this.axiosInstance.post<Result<BatterSingleSessionReportResultDto>>(
      `/api/v1/Report/sessionReviewReport/batterSingleSession/get-report-data`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportBatterSingleSessionUpdateReportSetup = async (
    requestBody: UpdateBatterSingleSessionReportSetupDto,
    reportId?: string
  ) => {
    const response = await this.axiosInstance.post<Result<BatterSingleSessionReportResultDto>>(
      `/api/v1/Report/sessionReviewReport/batterSingleSession/update-report-setup`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportBatterSingleSessionGenerate = async (requestBody: BatterSingleSessionReportFilterDto) => {
    const response = await this.axiosInstance.post<Result<BatterSingleSessionReportResultDto>>(
      `/api/v1/Report/sessionReviewReport/batterSingleSession/generate`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  getReportSessionReviewReportBatterSingleSessionOrgLayout = async () => {
    const response = await this.axiosInstance.get<Result<BatterSingleSessionReportLayoutResultDto>>(
      `/api/v1/Report/sessionReviewReport/batterSingleSession/org-layout`
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportBatterSingleSessionOrgLayout = async (requestBody: UpdateBatterSingleSessionReportLayoutDto) => {
    const response = await this.axiosInstance.post<Result<UpdateBatterSingleSessionReportLayoutDto>>(
      `/api/v1/Report/sessionReviewReport/batterSingleSession/org-layout`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportPitcherSingleSessionGetReportData = async (requestBody: PlayerReportContentConfigDto, reportId?: string) => {
    const response = await this.axiosInstance.post<Result<PitcherSingleSessionReportResultDto>>(
      `/api/v1/Report/sessionReviewReport/pitcherSingleSession/get-report-data`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportPitcherSingleSessionUpdateReportSetup = async (
    requestBody: UpdatePitcherSingleSessionReportSetupDto,
    reportId?: string
  ) => {
    const response = await this.axiosInstance.post<Result<PitcherSingleSessionReportResultDto>>(
      `/api/v1/Report/sessionReviewReport/pitcherSingleSession/update-report-setup`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportPitcherSingleSessionGenerate = async (requestBody: PitcherSingleSessionReportFilterDto) => {
    const response = await this.axiosInstance.post<Result<PitcherSingleSessionReportResultDto>>(
      `/api/v1/Report/sessionReviewReport/pitcherSingleSession/generate`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  getReportSessionReviewReportPitcherSingleSessionOrgLayout = async () => {
    const response = await this.axiosInstance.get<Result<PitcherSingleSessionReportLayoutResultDto>>(
      `/api/v1/Report/sessionReviewReport/pitcherSingleSession/org-layout`
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportPitcherSingleSessionOrgLayout = async (requestBody: UpdatePitcherSingleSessionReportLayoutDto) => {
    const response = await this.axiosInstance.post<Result<UpdatePitcherSingleSessionReportLayoutDto>>(
      `/api/v1/Report/sessionReviewReport/pitcherSingleSession/org-layout`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  getReportPracticeReportBatterSingleSessionOrgLayout = async () => {
    const response = await this.axiosInstance.get<Result<PracticeBatterSingleSessionReportLayoutResultDto>>(
      `/api/v1/Report/practiceReport/batterSingleSession/org-layout`
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportPracticeReportBatterSingleSessionGenerate = async (requestBody: PracticeBatterSingleSessionReportFilterDto) => {
    const response = await this.axiosInstance.post<Result<PracticeBatterSingleSessionReportResultDto>>(
      `/api/v1/Report/practiceReport/batterSingleSession/generate`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportPracticeReportBatterSingleSessionGetReportData = async (requestBody: PlayerReportContentConfigDto, reportId?: string) => {
    const response = await this.axiosInstance.post<Result<PracticeBatterSingleSessionReportResultDto>>(
      `/api/v1/Report/practiceReport/batterSingleSession/get-report-data`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportPracticeReportBatterSingleSessionUpdateReportSetup = async (
    requestBody: UpdatePracticeBatterSingleSessionReportSetupDto,
    reportId?: string
  ) => {
    const response = await this.axiosInstance.post<Result<PracticeBatterSingleSessionReportResultDto>>(
      `/api/v1/Report/practiceReport/batterSingleSession/update-report-setup`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportPracticeReportBatterSingleSessionOrgLayout = async (requestBody: UpdatePracticeBatterSingleSessionReportLayoutDto) => {
    const response = await this.axiosInstance.post<Result<UpdatePracticeBatterSingleSessionReportLayoutDto>>(
      `/api/v1/Report/practiceReport/batterSingleSession/org-layout`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportPracticeReportBatterSessionGetReportData = async (requestBody: PlayerReportContentConfigDto, reportId?: string) => {
    const response = await this.axiosInstance.post<Result<PracticeBatterSessionReportResultDto>>(
      `/api/v1/Report/practiceReport/batterSession/get-report-data`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportPracticeReportBatterSessionUpdateReportSetup = async (
    requestBody: UpdatePracticeBatterSessionReportSetupDto,
    reportId?: string
  ) => {
    const response = await this.axiosInstance.post<Result<PracticeBatterSessionReportResultDto>>(
      `/api/v1/Report/practiceReport/batterSession/update-report-setup`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportPracticeReportBatterSessionGenerate = async (requestBody: PracticeBatterSessionReportFilterDto) => {
    const response = await this.axiosInstance.post<Result<PracticeBatterSessionReportResultDto>>(
      `/api/v1/Report/practiceReport/batterSession/generate`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  getReportPracticeReportBatterSessionOrgLayout = async () => {
    const response = await this.axiosInstance.get<Result<PracticeBatterSessionReportLayoutResultDto>>(
      `/api/v1/Report/practiceReport/batterSession/org-layout`
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportPracticeReportBatterSessionOrgLayout = async (requestBody: UpdatePracticeBatterSessionReportLayoutDto) => {
    const response = await this.axiosInstance.post<Result<UpdatePracticeBatterSessionReportLayoutDto>>(
      `/api/v1/Report/practiceReport/batterSession/org-layout`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportPracticeReportPitcherSingleSessionGetReportData = async (requestBody: PlayerReportContentConfigDto, reportId?: string) => {
    const response = await this.axiosInstance.post<Result<PracticePitcherSingleSessionReportResultDto>>(
      `/api/v1/Report/practiceReport/pitcherSingleSession/get-report-data`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportPracticeReportPitcherSingleSessionUpdateReportSetup = async (
    requestBody: UpdatePracticePitcherSingleSessionReportSetupDto,
    reportId?: string
  ) => {
    const response = await this.axiosInstance.post<Result<PracticePitcherSingleSessionReportResultDto>>(
      `/api/v1/Report/practiceReport/pitcherSingleSession/update-report-setup`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportPracticeReportPitcherSingleSessionGenerate = async (requestBody: PracticePitcherSingleSessionReportFilterDto) => {
    const response = await this.axiosInstance.post<Result<PracticePitcherSingleSessionReportResultDto>>(
      `/api/v1/Report/practiceReport/pitcherSingleSession/generate`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  getReportPracticeReportPitcherSingleSessionOrgLayout = async () => {
    const response = await this.axiosInstance.get<Result<PracticePitcherSingleSessionReportLayoutResultDto>>(
      `/api/v1/Report/practiceReport/pitcherSingleSession/org-layout`
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportPracticeReportPitcherSingleSessionOrgLayout = async (requestBody: UpdatePracticePitcherSingleSessionReportLayoutDto) => {
    const response = await this.axiosInstance.post<Result<UpdatePracticePitcherSingleSessionReportLayoutDto>>(
      `/api/v1/Report/practiceReport/pitcherSingleSession/org-layout`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportPracticeReportPitcherSessionGetReportData = async (requestBody: PlayerReportContentConfigDto, reportId?: string) => {
    const response = await this.axiosInstance.post<Result<PracticePitcherSessionReportResultDto>>(
      `/api/v1/Report/practiceReport/pitcherSession/get-report-data`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportPracticeReportPitcherSessionUpdateReportSetup = async (
    requestBody: UpdatePracticePitcherSessionReportSetupDto,
    reportId?: string
  ) => {
    const response = await this.axiosInstance.post<Result<PracticePitcherSessionReportResultDto>>(
      `/api/v1/Report/practiceReport/pitcherSession/update-report-setup`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportPracticeReportPitcherSessionGenerate = async (requestBody: PracticePitcherSessionReportFilterDto) => {
    const response = await this.axiosInstance.post<Result<PracticePitcherSessionReportResultDto>>(
      `/api/v1/Report/practiceReport/pitcherSession/generate`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  getReportPracticeReportPitcherSessionOrgLayout = async () => {
    const response = await this.axiosInstance.get<Result<PracticePitcherSessionReportLayoutResultDto>>(
      `/api/v1/Report/practiceReport/pitcherSession/org-layout`
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportPracticeReportPitcherSessionOrgLayout = async (requestBody: UpdatePracticePitcherSessionReportLayoutDto) => {
    const response = await this.axiosInstance.post<Result<UpdatePracticePitcherSessionReportLayoutDto>>(
      `/api/v1/Report/practiceReport/pitcherSession/org-layout`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  getReportExternalReportBatterGenerate = async () => {
    const response = await this.axiosInstance.get<Result<ExternalBatterReportResultDto>>(`/api/v1/Report/externalReport/batter/generate`);
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  getReportExternalReportBatterOrgLayout = async () => {
    const response = await this.axiosInstance.get<Result<ExternalBatterReportLayoutResultDto>>(
      `/api/v1/Report/externalReport/batter/org-layout`
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  getReportExternalReportPitcherGenerate = async () => {
    const response = await this.axiosInstance.get<Result<ExternalPitcherReportResultDto>>(`/api/v1/Report/externalReport/pitcher/generate`);
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  getReportExternalReportPitcherOrgLayout = async () => {
    const response = await this.axiosInstance.get<Result<ExternalPitcherReportLayoutResultDto>>(
      `/api/v1/Report/externalReport/pitcher/org-layout`
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };
}

export default ReportService;
